import { generateClient } from "aws-amplify/api";
import { getMemberEmailBySub } from "../graphql/queries";
import {
  deleteMemberEmail,
  inviteMember,
  memberVerify,
} from "../graphql/mutations";

const client = generateClient();

const members = {
  getMembers: async (userData) => {
    const res = await client.graphql({
      query: getMemberEmailBySub,
      variables: {
        sub: userData,
      },
      authMode: "userPool",
    });
    return res.data;
  },

  addMember: async (userData) => {
    const res = await client.graphql({
      query: inviteMember,
      variables: {
        email: userData,
      },
      authMode: "userPool",
    });
    return res.data.inviteMember;
  },
  deleteMember: async (userData) => {
    const res = await client.graphql({
      query: deleteMemberEmail,
      variables: {
        input: userData,
      },
      authMode: "userPool",
    });
    return res.data;
  },
  verifyMember: async (verifyToken, sub) => {
    const response = await client.graphql({
      query: memberVerify,
      variables: {
        data: JSON.stringify({
          token: verifyToken,
          sub: sub,
        }),
      },
      authMode: "iam",
    });
    return response.data.memberVerify;
  },
  verifyMemberForLogIn: async (verifyToken, sub) => {
    const response = await client.graphql({
      query: memberVerify,
      variables: {
        data: JSON.stringify({
          token: verifyToken,
          sub: sub,
        }),
      },
      authMode: "userPool",
    });
    return response.data.memberVerify;
  },
};

export default members;
